import { createContext, ReactNode, useContext } from "react";

import { useFilterSplashScreen } from "./filter-splash-screen.hook";

const FilterSplashScreenContext = createContext(
  {} as ReturnType<typeof useFilterSplashScreen>
);
export function useFilterSplashScreenContext() {
  return useContext(FilterSplashScreenContext);
}

interface FilterSplashScreenProviderProps {
  children: ReactNode;
}
export function FilterSplashScreenProvider({
  children,
}: FilterSplashScreenProviderProps) {
  return (
    <FilterSplashScreenContext.Provider value={useFilterSplashScreen()}>
      {children}
    </FilterSplashScreenContext.Provider>
  );
}